import {useCreateCheckoutSession} from '@tinct/core-api';
import {CheckoutSessionResponse} from '@tinct/core-api-models';

export function usePaywallCheckout() {
  const { mutate: createCheckoutSession, isPending: isCheckoutPending } = useCreateCheckoutSession({
    onSuccess: (data: CheckoutSessionResponse) => {
      if (data.checkoutUrl) {
        window.location.href = data.checkoutUrl;
      }
    },
  });

  return { createCheckoutSession, isCheckoutPending };
}
